import PropTypes from "prop-types";
import React, { Component } from "react";

import HamburgerMenu from "./HamburgerMenu";

import Analytics from "../../utils/chat/Analytics";
import { EVENT_ACTIONS } from "../../constants/AnalyticsConstants";
import { history } from "../../utils/chat/chatNavigation";

class HamburgerMenuContainer extends Component {
    constructor() {
        super();

        this.onClickMenu = this.onClickMenu.bind(this);
    }

    onClickMenu() {
        if (!this.props.isDisabled) {
            Analytics.sendGaEvent({ action: EVENT_ACTIONS.MenuForListMenuClicked });
            history.push("list");
        }
    }

    render() {
        return <HamburgerMenu isDisabled={this.props.isDisabled} onClick={this.onClickMenu} />;
    }
}

HamburgerMenuContainer.propTypes = {
    isDisabled: PropTypes.bool.isRequired,
};

export default HamburgerMenuContainer;
